import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClienteListarComponent } from './cliente-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ClienteListarComponent }
    ])],
    exports: [RouterModule]
})
export class ClienteListarRoutingModule { }
